// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AdvisoriesIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 18 21">
    <path
      fill="currentColor"
      d="M9.69 5.75a.75.75 0 0 0-1.5 0v5.5a.75.75 0 0 0 1.5 0zM8.94 15.09a.88.88 0 1 0 0-1.76.88.88 0 0 0 0 1.76"
    />
    <path
      fill="currentColor"
      d="m9 1.44 7.56 3V9c0 4.32-3.46 8.4-7.56 9.57C4.9 17.39 1.44 13.31 1.44 9V4.48l7.56-3M9 0q-.3 0-.56.11L.87 3.16A1.4 1.4 0 0 0 0 4.48V9c0 5 3.85 9.59 8.61 11q.39.12.78 0C14.15 18.58 18 14 18 9V4.48a1.4 1.4 0 0 0-.87-1.32L9.56.11Q9.29.01 9 0"
    />
  </svg>,
  "Advisories",
);
export default AdvisoriesIcon;
